import { serviceInstance } from 'libs';
import { merchantId } from 'store/actions/wallet-history';

export default {
  fetchMerchantProfile: (id) =>
    serviceInstance.get(`/merchant/users/${id}`).then(({ data, status }) => ({
      ...data,
      status,
    })),

  updateMerchantProfile: (id, body) =>
    serviceInstance
      .put(`/merchant/users/${id}`, body)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  updateMerchantBusiness: (id, body) =>
    serviceInstance
      .put(`/api/merchant/${id}`, body)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  verifyBVN: (bvn) =>
    serviceInstance
      .get(`verification/bvn/${bvn}/lookup`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  //v2 endpoints
  postMerchantSetup: (id, stage, body) =>
    serviceInstance
      .post(`v2/merchant/${id}/account/setup/${stage}`, body)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  getVerificationTypes: () =>
    serviceInstance.get('verification/types').then(({ data, status }) => ({
      ...data,
      status,
    })),

  verifyIdentity: (typeId, body) =>
    serviceInstance
      .post(`/verification/verify-identity?typeId=${typeId}`, body)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  fetchBusinessSetup: (merchantId) =>
    serviceInstance
      .get(`/v2/merchant/${merchantId}/account/setup/stages`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  fetchBankDetails: (merchantId) =>
    serviceInstance
      .get(`/api/merchant/get-kta?merchantId=${merchantId}`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
};
